import { Box, Typography } from '@mui/material';

const RotatingCardBack = ({
    color = 'info',
    image,
    title,
    description,
    action,
    bgPosition = null,
}) => {
    return (
        <Box
            //className='backCard'
            display='flex'
            justifyContent='center'
            alignItems='center'
            borderRadius={3}
            boxShadow={color}
            position='absolute'
            width='100%'
            height='100%'
            background='transparent'
            top={0}
            left={0}
            zIndex={5}
            //variant='contained'
            //opacity={1}
            sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                transform: 'rotateY(180deg)',
                backfaceVisibility: 'hidden',
                ...(bgPosition !== null && { backgroundPosition: bgPosition }),
            }}
        >
            <Box pt={12} pb={2} px={2} textAlign='center' lineHeight={1}>
                <Typography variant='h3' color='white' gutterBottom>
                    {title}
                </Typography>
                <Typography variant='body2' color='white' opacity={0.8}>
                    {description}
                </Typography>
                {/* {action && (
                    <Box width='50%' mt={4} mb={2} mx='auto'>
                        {action.type === 'external' ? (
                            <Button
                                component={MuiLink}
                                href={action.route}
                                target='_blank'
                                rel='noreferrer'
                                //color='white'
                                size='small'
                                fullWidth
                            >
                                {action.label}
                            </Button>
                        ) : (
                            <Button
                                component={Link}
                                to={action.route}
                                //color='white'
                                size='small'
                                fullWidth
                            >
                                {action.label}
                            </Button>
                        )}
                    </Box>
                )} */}
            </Box>
        </Box>
    );
};

export default RotatingCardBack;
